type Tag = {
  text?: string | null | undefined
  icon?: string | null | undefined
}

export const isValidTag = (tag?: Tag): tag is Tag =>
  tag != null && tag.text != null && tag.text.length > 0
